// extracted by mini-css-extract-plugin
module.exports = {"form":"MItemForm_form__2AtzC"};